module.exports = require("swa-motion-point/motionPoint");